import React from 'react';
import { getProposalEntry, slidesForProposal } from './proposalRegistry';

/**
 * ProposalViewer — read-only view of a proposal.
 *
 * Used by:
 *   • Guest side of MeetingRoom (slideIdx & payload come from signaling sync)
 *   • PublicRevisitPage (slideIdx 0 by default; client navigates themselves)
 *
 * Pure presentational; the parent owns state.
 */
const ProposalViewer = ({
  type = 'consolidation',
  payload,
  slideIdx = 0,
  clientName,
  brokerName,
  accepted = false,
  onAccept,
  showSlideNav = false,
  onSlideChange,
}) => {
  const entry = getProposalEntry(type);
  const slides = slidesForProposal(type, payload);
  const max = slides.length - 1;
  const idx = Math.max(0, Math.min(max, slideIdx));

  return (
    <div className="absolute inset-0 z-30 bg-slate-100 flex flex-col" data-testid="proposal-viewer">
      <div className={`flex-1 min-h-0 overflow-y-auto ${showSlideNav ? '' : 'pb-2'}`}>
        {entry.render({
          index: idx,
          payload: payload || {},
          clientName,
          brokerName,
          readonly: true,
          accepted,
          onAccept,
        })}
      </div>

      {/* Optional client-side nav (used on revisit page; hidden during live sync) */}
      {showSlideNav && (
        <div className="bg-slate-950/85 backdrop-blur text-white px-4 py-3 flex items-center justify-center gap-2 z-10 shrink-0">
          {slides.map((s, i) => (
            <button
              key={s.key}
              onClick={() => onSlideChange?.(i)}
              data-testid={`viewer-slide-${i}`}
              className={`min-w-[28px] h-1.5 rounded-full transition-all ${
                i === idx ? 'bg-emerald-400 w-8' : 'bg-white/20 hover:bg-white/40'
              }`}
              title={s.title}
            />
          ))}
          <span className="text-xs text-slate-400 ml-3">{idx + 1} / {slides.length}</span>
        </div>
      )}
    </div>
  );
};

export default ProposalViewer;
